import { MomentService } from './../../../../shared/services/moment.service';
import { Component, OnInit } from '@angular/core';
import { StpService } from 'src/app/shared/services/stp.service';

@Component({
  selector: 'app-stp-abono-default',
  templateUrl: './stp-abono-default.component.html',
  styleUrls: ['./stp-abono-default.component.scss']
})
export class StpAbonoDefaultComponent implements OnInit {
  public abonos: any[] = [];
  constructor(
    private STPService: StpService,
    private moment: MomentService
  ) { }

  ngOnInit() {
    this.getAbonos();
  }

  public getAbonos() {
    this.STPService.getAbonos().subscribe(
      (res: any) => {
        console.log(res);
        if(res.error) {
          console.log(res);
        } else if(res.data) {
          res.data.forEach(abono => {
            abono.fechaOperacion = this.moment.format(abono.fechaOperacion,'YYYY-MM-DD','YYYYMMDD');
            abono.fechaRegistro = this.moment.format(abono.dateCreated,'YYYY-MM-DD hh:mm A');
          });
          console.log(res.data);
          this.abonos = res.data;
        }
      },
      error => {
        console.log(error);
    });
  }

  sendAbonoCacao() {
    console.log('Aprobar Abono - Enviar a Cacao y agregar Balance a Compañia');
  }

}
